import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { FolderTreeComponent } from 'src/app/components/folder-tree/folder-tree.component';
import { LoadingService } from 'src/app/components/loading/loading.service';
import { CreateFolderModalComponent } from 'src/app/components/modal/create-folder-modal/create-folder-modal.component';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { FolderHierarchy } from 'src/app/models/folder-hierarchy.model';
import { EncryptedMoveModel } from 'src/app/models/storage.model';
import { isSafeLockEnable } from 'src/app/pages/encrypted-storage/login-screen/login-screen.component';
import { MyStorageService } from 'src/app/pages/storage/storage.service';
import { TrashService } from 'src/app/pages/trash/trash.service';
import { CommonService } from 'src/app/services/common.service';
import { ModalService } from 'src/app/services/modal.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SearchService } from 'src/app/services/search.service';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as SgeCrypto from 'src/assets/lib/sge/sge-crypto';
@Component({
  selector: 'app-folder-tree-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent, FolderTreeComponent, CreateFolderModalComponent, TranslateModule],
  providers: [HttpClient, LoadingService],
  templateUrl: './folder-tree-modal.component.html',
  styleUrls: ['./folder-tree-modal.component.scss'],
})
export class FolderTreeModalComponent implements OnInit, OnDestroy {
  @Input() selectedFolderId?: string;
  @Input() selectedFolderorFile?: any;
  @Input() initialized = false;
  @Input() selectedItems: any;
  @Output() newFolderClicked = new EventEmitter<string>();
  @ViewChild('modalContainer')
  modalContainer!: ElementRef;

  @ViewChild('btnCancelRef') btnCancelRef!: ElementRef;

  subscription: Subscription = new Subscription();
  folderSubscription: Subscription = new Subscription();
  unsubscribe$ = new Subject<boolean>();
  searchSubscription = new Subscription();
  folderHierarchySubscription: Subscription = new Subscription();
  isEncryptedSubscription = new Subscription();
  notEncryptedSubscription = new Subscription();
  encryptedIdSubscription = new Subscription();
  copySubscription = new Subscription();

  //string
  modalId = 'folderTreeModal';
  selectedFolder?: FolderHierarchy;
  selectedFolderHierarchyId!: string | null;
  selectedEncryptedFolderHierarchyId?: string;
  modalTitle!: string;
  parentEncrpytedId!: string;

  //boolean
  fromFolderTree?: boolean;
  firstClicked = false;
  isCopy = false;
  isSearchDetail = false;
  selectedItemIdList: any = [];
  selectedEncryptedItemIdLists: any = [];
  selectedEncryptedItemList: any = [];
  isSelectedItemEncrypted = false;
  isShares = false;
  isTrash = false;

  //object
  folders!: FolderHierarchy[];

  constructor(
    public commonService: CommonService,
    private myStorageService: MyStorageService,
    private notificationService: NotificationService,
    private router: Router,
    private searchService: SearchService,
    private trashService: TrashService,
    public loadingService: LoadingService,
    private modalService: ModalService,
  ) {
    this.isEncryptedSubscription.add(
      this.commonService.isEncrypted$.subscribe((value) => {
        this.getFolderHierarchy(value);
        this.isSelectedItemEncrypted = value;
      }),
    );
    this.folderSubscription = this.commonService.isCopyClicked.subscribe((value) => {
      this.isCopy = value;
      this.modalTitle = this.isCopy ? this.commonService.getTranslatedMessage('COPY') : this.commonService.getTranslatedMessage('FILE_MOVING');
    });
    this.searchSubscription = searchService.isSearhDetail$.subscribe((value) => {
      this.isSearchDetail = value;
      this.modalTitle = this.commonService.getTranslatedMessage('SELECT_FOLDER');
    });
    this.encryptedIdSubscription = commonService.encryptedId$.subscribe((value) => {
      this.parentEncrpytedId = value;
    });
    this.isShares = this.router.url.startsWith('/paylasimlar');
    this.isTrash = this.router.url.startsWith('/cop-kutusu');
  }

  ngOnInit(): void {
    if (this.isShares) {
      this.modalTitle = this.commonService.getTranslatedMessage('IMPORT_MY_STORAGE');
    }
    if (this.isTrash) {
      this.modalTitle = this.commonService.getTranslatedMessage('DIRECTORY_TO_RESTORE');
    }
  }

  ngOnDestroy(): void {
    this.getUnsubscribes();
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
    setTimeout(() => {
      this.commonService.setOpenedModalId('');
    }, 100);
  }

  onCloseModal(): void {
    this.btnCancelRef.nativeElement.click();
    this.commonService.setFolderTreeModalOpened(false);
    this.commonService.selectedId = 1;
    this.modalService.closeModalManually(this.modalId);
  }

  getUnsubscribes(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.folderHierarchySubscription) {
      this.folderHierarchySubscription.unsubscribe();
    }
    if (this.folderSubscription) {
      this.folderSubscription.unsubscribe();
    }
    if (this.isEncryptedSubscription) {
      this.isEncryptedSubscription.unsubscribe();
    }
    if (this.notEncryptedSubscription) {
      this.notEncryptedSubscription.unsubscribe();
    }
    if (this.encryptedIdSubscription) {
      this.encryptedIdSubscription.unsubscribe();
    }
    if (this.copySubscription) {
      this.copySubscription.unsubscribe();
    }
  }

  onAddFolder(): void {
    const modalId = this.isSelectedItemEncrypted ? '#createEncryptedFolderModal' : '#createFolderModal';
    this.onCloseModal();
    this.newFolderClicked.emit(modalId);
  }

  onButtonClicked(event: Event): void {
    this.changeIconOnClick(event);
  }

  getFolderHierarchy(encrypted?: boolean): void {
    this.loadingService.setLoading(true);
    this.folders = [];
    const encryptedFolder = !!encrypted;
    this.folderHierarchySubscription = this.myStorageService.getFolderHierarchy(encryptedFolder).subscribe({
      next: (res: FolderHierarchy) => {
        this.folders = [res];
      },
      error: () => {
        this.loadingService.setLoading(false);
      },
      complete: () => {
        this.loadingService.setLoading(false);
      },
    });
  }

  changeIconOnClick(event: Event): void {
    const icon = event.target as HTMLElement;
    if (icon.classList.contains('ti-add-plus-circle')) {
      icon.classList.remove('ti-add-plus-circle');
      icon.classList.add('ti-minus-circle');
    } else if (icon.classList.contains('ti-minus-circle')) {
      icon.classList.remove('ti-minus-circle');
      icon.classList.add('ti-add-plus-circle');
    }
  }

  selectFolder(): void {
    if (this.selectedFolder) {
      this.searchService.setFolder(this.selectedFolder);
      this.onCloseModal();
    }
  }

  reverseOperation(): void {
    if (isSafeLockEnable) {
      SgeCrypto.listEncryptedFolder(this.selectedFolder?.parent.encryptedId).then((fileList: any) => {
        const fileIndex = fileList.findIndex((file: any) => {
          if (this.selectedItems.length > 0) {
            return file.name === this.selectedItems[0]?.objectName;
          } else {
            return file.name === this.selectedFolderorFile?.objectName;
          }
        });
        if (fileIndex >= 0) {
          const notification = {
            message: this.commonService.getTranslatedMessage('OBJECT_ALREADY_EXISTS'),
          };
          this.notificationService.errorNotification(notification);
        } else {
          this.reverseTrash();
        }
      });
    }
  }

  async reverseTrash(): Promise<void> {
    const ids = this.selectedItems?.map((item: any) => item.objectId);
    this.subscription = this.trashService.restoreItems(ids!, this.selectedFolderHierarchyId!).subscribe({
      next: (res: any) => {
        let notificationMessage = '';
        if (res.successList && res.successList.length > 0) {
          const successEncryptedIdList = res.successList.filter((item: any) => item.directory === false && item.encryptedId !== null).map((item: any) => item.encryptedId);
          if (successEncryptedIdList.length > 0) {
            successEncryptedIdList.forEach(async (encryptedId: any) => {
              let success = true;
              success = success && (await SgeCrypto.restoreEncryptedNode(this.selectedEncryptedFolderHierarchyId, encryptedId));
            });
            const notification = {
              message: this.commonService.getTranslatedMessage('SELECTIONS_RESTORED_SUCCESSFULLY'),
            };
            this.notificationService.successNotification(notification);
            this.trashService.restoreSubcription.next(true);
          }
          this.onCloseModal();

          return;
        }
        if (res.successList.length === 0 && res.failList.length > 0) {
          notificationMessage = this.myStorageService.getExistingFailListMessages(res.failList, notificationMessage, false, true);

          if (notificationMessage) {
            this.notificationService.errorNotification({ message: notificationMessage });

            return;
          }
        }
      },
    });
  }

  moveEncryptedFolderoperation(): void {
    if (isSafeLockEnable) {
      SgeCrypto.listEncryptedFolder(this.selectedFolder?.parent.encryptedId).then((fileList: any) => {
        const fileIndex = fileList.findIndex((file: any) => {
          file.name === this.selectedItems[0]?.objectName || file.name === this.selectedFolder?.parent.name;
        });
        if (fileIndex >= 0) {
          const notification = {
            message: this.commonService.getTranslatedMessage('FOLDER_ALREADY_EXISTS'),
          };
          this.notificationService.errorNotification(notification);
        } else {
          this.moveFolder();
        }
      });
    }
  }

  moveFolder(): void {
    const selectedItemListId = this.commonService.collectObjectIds(this.selectedItems);
    const encryptedIds = this.commonService.collectEncryptedIds(this.selectedItems);
    const encryptedMoveObj: EncryptedMoveModel = {
      destinationId: this.selectedFolder?.parent.encryptedId ?? null,
      parentId: this.parentEncrpytedId || null,
      encryptedIds,
    };
    this.myStorageService.moveFolderFunction(selectedItemListId, this.selectedFolderHierarchyId!, encryptedMoveObj).then(() => {
      this.commonService.rebindListener.next();
      this.commonService.isDetailClicked.next(false);
      this.onCloseModal();
    });
  }

  moveToEncryptedStorage(): void {
    let successEncryptedIdList: any[] = [];
    const selectedItemListId = this.commonService.collectObjectIds(this.selectedItems);
    if (selectedItemListId.length > 0) {
      this.subscription = this.myStorageService.multiCopyObjectToMyStorage(selectedItemListId, this.selectedFolderHierarchyId!).subscribe({
        next: (res) => {
          let notificationMessage = '';
          this.commonService.quotaChange$.next(true);
          if (res.successList && res.successList.length > 0) {
            successEncryptedIdList = res.successList.map((item: any) => item.encryptedId);
            if (successEncryptedIdList.length > 0) {
              successEncryptedIdList.forEach(async (encryptedId) => {
                try {
                  const fileList2 = await SgeCrypto.transferEncryptedNodes(this.selectedEncryptedFolderHierarchyId, encryptedId);

                  const renameObj = [res];
                  const renameObjList: any[] = [];
                  let errorRenameLength = 0;
                  let successRenameLength = 0;

                  renameObj.forEach((rObjn: any) => {
                    rObjn.successList.forEach((rObj: any) => {
                      rObj.returnData.forEach((returnDataItem: any) => {
                        const { predecessorEncryptedId, createdObjectId } = returnDataItem;
                        const fileIndexObjId = fileList2.findIndex((filee: { oldId: any }) => filee.oldId === predecessorEncryptedId);
                        if (fileIndexObjId >= 0) {
                          renameObjList.push({
                            createdObjectId,
                            successorEncryptedId: fileList2[fileIndexObjId].newId,
                          });
                          successRenameLength++;
                        } else {
                          errorRenameLength++;
                        }
                      });
                    });
                  });

                  if (successRenameLength > 0) {
                    await this.myStorageService.changeEncrptedIds(renameObjList).toPromise();
                    this.getFolderHierarchy(true);
                    const notification = {
                      message: this.commonService.getTranslatedMessage('OPERATION_SUCCESSFUL'),
                    };
                    this.notificationService.successNotification(notification);
                    this.commonService.rebindListener.next();
                  }
                } catch (error) {
                  const notification = {
                    message: this.commonService.getTranslatedMessage('ERROR_OCCURRED') + error,
                  };
                  this.notificationService.errorNotification(notification);
                }
              });
            }
          }
          if (res.failList && res.failList.length > 0) {
            notificationMessage = this.myStorageService.getExistingFailListMessages(res.failList, notificationMessage, false, true);

            if (notificationMessage) {
              this.notificationService.errorNotification({ message: notificationMessage });

              return;
            }
          }
        },
        error: (err) => {
          if (err?.Error?.message === 'OBJECT_ALREADY_EXISTS') {
            const notification = {
              message: this.commonService.getTranslatedMessage('OBJECT_ALREADY_EXISTS'),
            };
            this.notificationService.errorNotification(notification);
          }
          if (err?.Error?.message === 'USER_NOT_AUTHORIZED') {
            const notification = {
              message: this.commonService.getTranslatedMessage('USER_NOT_AUTHORIZED'),
            };
            this.notificationService.errorNotification(notification);
          }
        },
        complete: () => {
          this.onCloseModal();
          this.commonService.isDetailClicked.next(false);
        },
      });
    } else if (this.selectedFolderId) {
      this.subscription = this.myStorageService.copyObjectToMyStorage(this.selectedFolderId, this.selectedFolderHierarchyId!).subscribe({
        next: async (res) => {
          try {
            const fileList2 = await SgeCrypto.transferEncryptedNodes(this.selectedEncryptedFolderHierarchyId, this.selectedFolderorFile.encryptedId);

            const renameObj = [res];
            const renameObjList: any[] = [];
            let errorRenameLength = 0;
            let successRenameLength = 0;

            renameObj.forEach((rObjn: any) => {
              if (Array.isArray(rObjn)) {
                rObjn.forEach((rObj: any) => {
                  const { predecessorEncryptedId } = rObj;
                  const { createdObjectId } = rObj;
                  const fileIndexObjId = fileList2.findIndex((filee: { oldId: any }) => filee.oldId === predecessorEncryptedId);
                  if (fileIndexObjId >= 0) {
                    renameObjList.push({
                      createdObjectId,
                      successorEncryptedId: fileList2[fileIndexObjId].newId,
                    });
                    successRenameLength++;
                  } else {
                    errorRenameLength++;
                  }
                });
              }
            });

            if (successRenameLength > 0) {
              await this.myStorageService.changeEncrptedIds(renameObjList).toPromise();
              this.getFolderHierarchy(true);
              const notification = {
                message: this.commonService.getTranslatedMessage('OPERATION_SUCCESSFUL'),
              };
              this.notificationService.successNotification(notification);
              this.commonService.rebindListener.next();
            }
          } catch (error) {
            const notification = {
              message: this.commonService.getTranslatedMessage('ERROR_OCCURRED') + error,
            };
            this.notificationService.errorNotification(notification);
          }

          this.commonService.quotaChange$.next(true);
        },
        error: (err) => {
          if (err?.Error?.message === 'OBJECT_ALREADY_EXISTS') {
            const notification = {
              message: this.commonService.getTranslatedMessage('OBJECT_ALREADY_EXISTS'),
            };
            this.notificationService.errorNotification(notification);
          }
          if (err?.Error?.message === 'USER_NOT_AUTHORIZED') {
            const notification = {
              message: this.commonService.getTranslatedMessage('USER_NOT_AUTHORIZED'),
            };
            this.notificationService.errorNotification(notification);
          }
        },
        complete: () => {
          this.onCloseModal();
          this.commonService.isDetailClicked.next(false);
        },
      });
    }
  }

  moveToEncryptedStorageFolderOperation(): void {
    if (isSafeLockEnable) {
      SgeCrypto.listEncryptedFolder(this.selectedFolder?.parent.encryptedId).then((fileList: any) => {
        const fileIndex = fileList.findIndex((file: any) => {
          if (this.selectedItems.length > 0) {
            return file.name === this.selectedItems[0]?.objectName;
          } else {
            return file.name === this.selectedFolderorFile?.objectName;
          }
        });
        if (fileIndex >= 0) {
          const notification = {
            message: this.commonService.getTranslatedMessage('FOLDER_ALREADY_EXISTS'),
          };
          this.notificationService.errorNotification(notification);
        } else {
          this.moveToEncryptedStorage();
        }
      });
    }
  }

  moveToStorage(): void {
    const selectedItemListId = this.commonService.collectObjectIds(this.selectedItems);
    if (selectedItemListId.length > 1) {
      this.subscription = this.myStorageService.multiCopyObjectToMyStorage(selectedItemListId, this.selectedFolderHierarchyId!).subscribe({
        next: () => {
          this.commonService.quotaChange$.next(true);
          this.getFolderHierarchy(false);
          const notification = {
            message: this.commonService.getTranslatedMessage('OPERATION_SUCCESSFUL'),
          };
          this.notificationService.successNotification(notification);
          this.commonService.rebindListener.next();
        },
        error: () => {
          const notification = {
            message: this.commonService.getTranslatedMessage('ERROR_OCCURRED'),
          };
          this.notificationService.errorNotification(notification);
        },
        complete: () => {
          this.onCloseModal();
        },
      });
    } else if (this.selectedFolderId) {
      this.subscription = this.myStorageService.copyObjectToMyStorage(this.selectedFolderId, this.selectedFolderHierarchyId!).subscribe({
        next: () => {
          this.commonService.quotaChange$.next(true);
          this.getFolderHierarchy(false);
          const notification = {
            message: this.commonService.getTranslatedMessage('OPERATION_SUCCESSFUL'),
          };
          this.notificationService.successNotification(notification);
        },
        complete: () => {
          this.onCloseModal();
          this.commonService.isDetailClicked.next(false);
        },
      });
    }
  }

  copyEncryptedFolderOperation(): void {
    if (isSafeLockEnable) {
      SgeCrypto.listEncryptedFolder(this.selectedFolder?.parent.encryptedId).then((fileList: any) => {
        const fileIndex = fileList.findIndex((filee: any) => {
          if (this.selectedItems[0]) {
            return filee.name === this.selectedItems[0]?.objectName;
          }
          return false;
        });
        if (fileIndex >= 0) {
          const notification = {
            message: this.commonService.getTranslatedMessage('FOLDER_ALREADY_EXISTS'),
          };
          this.notificationService.errorNotification(notification);
        } else {
          this.copyToEncryptedDirectory();
        }
      });
    }
  }

  copyToEncryptedDirectory(): void {
    let successEncryptedIdList: any[] = [];
    this.selectedItemIdList = this.commonService.collectObjectIds(this.selectedItems);
    if (this.selectedItemIdList.length > 0) {
      this.subscription = this.myStorageService.multiCopyToDirectory(this.selectedItemIdList, this.selectedFolderHierarchyId!).subscribe({
        next: (res) => {
          let notificationMessage = '';
          if (res.successList && res.successList.length > 0) {
            successEncryptedIdList = res.successList.map((item: any) => item.encryptedId);
            const currentPath = this.parentEncrpytedId;
            this.selectedEncryptedItemIdLists = this.commonService.collectEncryptedIds(this.selectedItems);
            this.commonService.quotaChange$.next(true);
            this.getFolderHierarchy(true);
            SgeCrypto.copyEncryptedNodes(currentPath, this.selectedEncryptedFolderHierarchyId, successEncryptedIdList).then((fileList2: any) => {
              const renameObj = [res];
              const renameObjList: any[] = [];
              let errorRenameLength = 0;
              let successRenameLength = 0;
              renameObj.forEach((rObjn: any) => {
                if (rObjn.successList && Array.isArray(rObjn.successList)) {
                  rObjn.successList.forEach((rObj: any) => {
                    rObj.returnData.forEach((returnDataItem: any) => {
                      const { predecessorEncryptedId, createdObjectId } = returnDataItem;
                      const fileIndexObjId = fileList2.findIndex((filee: { oldId: any }) => filee.oldId === predecessorEncryptedId);
                      if (fileIndexObjId >= 0) {
                        renameObjList.push({
                          createdObjectId,
                          successorEncryptedId: fileList2[fileIndexObjId].newId,
                        });
                        successRenameLength++;
                      } else {
                        errorRenameLength++;
                      }
                    });
                  });
                }
              });

              if (successRenameLength > 0) {
                this.myStorageService.changeEncrptedIds(renameObjList).subscribe({
                  next: () => {
                    notificationMessage = this.commonService.getTranslatedMessage('OPERATION_SUCCESSFUL') + '\n';
                    this.getFolderHierarchy(true);
                    if (res.failList.length > 0) {
                      notificationMessage = this.commonService.getTranslatedMessage('COPY_MOVE_OPERATION_FAILED') + '\n';
                      notificationMessage = this.myStorageService.getExistingFailListMessages(res.failList, notificationMessage, true);

                      if (notificationMessage) {
                        this.notificationService.errorNotification({ message: notificationMessage });

                        return;
                      }
                    } else {
                      this.notificationService.successNotification({ message: notificationMessage });
                    }
                  },
                  error: () => {
                    const notification = {
                      message: this.commonService.getTranslatedMessage('ERROR_OCCURRED'),
                    };
                    this.notificationService.errorNotification(notification);
                  },
                });
              }
            });
          }
          if (res.successList.length === 0 && res.failList.length > 0) {
            notificationMessage = this.myStorageService.getExistingFailListMessages(res.failList, notificationMessage, true);

            if (notificationMessage) {
              this.notificationService.errorNotification({ message: notificationMessage });

              return;
            }
          }
          this.commonService.rebindListener.next();
        },
        error: () => {
          const notification = {
            message: this.commonService.getTranslatedMessage('ERROR_OCCURRED'),
          };
          this.notificationService.errorNotification(notification);
        },
        complete: () => {
          this.onCloseModal();
          this.commonService.selectedFolderHierarchy$.next({} as FolderHierarchy);
        },
      });
    } else if (this.selectedFolderId) {
      this.copySubscription = this.myStorageService.copyToDirectory(this.selectedFolderId, this.selectedFolderHierarchyId!).subscribe({
        next: async (res) => {
          const currentPath = this.parentEncrpytedId;
          try {
            const fileList2 = await SgeCrypto.copyEncryptedNodes(currentPath, this.selectedEncryptedFolderHierarchyId, this.selectedFolderorFile.encryptedId);

            const renameObj = [res];
            const renameObjList: any[] = [];
            let errorRenameLength = 0;
            let successRenameLength = 0;

            renameObj.forEach((rObjn: any) => {
              if (Array.isArray(rObjn)) {
                rObjn.forEach((rObj: any) => {
                  const { predecessorEncryptedId } = rObj;
                  const { createdObjectId } = rObj;
                  const fileIndexObjId = fileList2.findIndex((filee: { oldId: any }) => filee.oldId === predecessorEncryptedId);
                  if (fileIndexObjId >= 0) {
                    renameObjList.push({
                      createdObjectId,
                      successorEncryptedId: fileList2[fileIndexObjId].newId,
                    });
                    successRenameLength++;
                  } else {
                    errorRenameLength++;
                  }
                });
              }
            });

            if (successRenameLength > 0) {
              await this.myStorageService.changeEncrptedIds(renameObjList).toPromise();
              this.getFolderHierarchy(true);
              const notification = {
                message: this.commonService.getTranslatedMessage('OPERATION_SUCCESSFUL'),
              };
              this.notificationService.successNotification(notification);
              this.commonService.rebindListener.next();
            }
          } catch (error) {
            const notification = {
              message: this.commonService.getTranslatedMessage('ERROR_OCCURRED') + error,
            };
            this.notificationService.errorNotification(notification);
          }

          this.commonService.quotaChange$.next(true);
        },
        complete: () => {
          this.onCloseModal();
          this.commonService.multipleSelectedItems$.next([]);
        },
      });
    }
  }

  copyToDirectory(): void {
    const selectedItemIdList = this.commonService.collectObjectIds(this.selectedItems);
    if (selectedItemIdList.length > 1) {
      this.copySubscription = this.myStorageService.multiCopyToDirectory(selectedItemIdList, this.selectedFolderHierarchyId!).subscribe({
        next: (res) => {
          let notificationMessage = '';
          if (res.successList.length > 0) {
            this.commonService.quotaChange$.next(true);
            this.getFolderHierarchy(false);
            notificationMessage = this.commonService.getTranslatedMessage('OPERATION_SUCCESSFUL') + '\n';
            if (res.failList.length > 0) {
              notificationMessage = this.commonService.getTranslatedMessage('COPY_MOVE_OPERATION_FAILED') + '\n';
              notificationMessage = this.myStorageService.getExistingFailListMessages(res.failList, notificationMessage, true);

              if (notificationMessage) {
                this.notificationService.errorNotification({ message: notificationMessage });

                return;
              }
            } else {
              if (notificationMessage) {
                this.notificationService.successNotification({ message: notificationMessage });
              }
            }
          }
          if (res.successList.length === 0 && res.failList.length > 0) {
            notificationMessage = this.myStorageService.getExistingFailListMessages(res.failList, notificationMessage, true);

            if (notificationMessage) {
              this.notificationService.errorNotification({ message: notificationMessage });

              return;
            }
          }
          this.commonService.rebindListener.next();
        },
        complete: () => {
          this.onCloseModal();
          this.commonService.multipleSelectedItems$.next([]);
          this.commonService.selectedFolderHierarchy$.next({} as FolderHierarchy);
        },
      });
    } else if (this.selectedFolderId) {
      this.copySubscription = this.myStorageService.copyToDirectory(this.selectedFolderId, this.selectedFolderHierarchyId!).subscribe({
        next: () => {
          this.commonService.quotaChange$.next(true);
          this.getFolderHierarchy(false);
          const notification = {
            message: this.commonService.getTranslatedMessage('OPERATION_SUCCESSFUL'),
          };
          this.notificationService.successNotification(notification);
          this.commonService.rebindListener.next();
        },
        complete: () => {
          this.onCloseModal();
          this.commonService.multipleSelectedItems$.next([]);
          this.commonService.selectedFolderHierarchy$.next({} as FolderHierarchy);
        },
      });
    }
  }

  getSelectedFolderHiearachy(folder: FolderHierarchy): void {
    this.commonService.selectedId = 1;
    this.firstClicked = true;
    this.selectedFolderHierarchyId = folder?.parent?.objectId ?? null;
    this.selectedEncryptedFolderHierarchyId = folder.parent.encrypted ? folder.parent.encryptedId : undefined;
    this.selectedFolder = folder;
    this.commonService.selectedFolderHierarchy$.next(folder);
  }

  //TODO: collapse animasyonu devam ederken button disable edilecek veya collapse animasyonu kaldırılacak
}
